export default "__VITE_ASSET__DtdP1k2p__"